<app-page-header title="Agent Sale Performance" subtitle="View agent performance metrics and conversion rates"></app-page-header>

<div class="sale-performance-container">
    <p-card styleClass="table-card">
        <app-table-component
            [cols]="cols"
            [data]="tableData() || []"
            [loading]="tableLoading()"
            [pagination]="false"
            [oddRowColor]="'#ffffff'"
            [evenRowColor]="'#f8fafc'"
        >
        </app-table-component>
    </p-card>
</div>

<!-- Templates -->
<ng-template #revenueTemplate let-rowData="rowData">
    <span>{{ rowData.revenue.amount | currency: rowData.revenue.currency }}</span>
</ng-template>
